<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { setSession, getSession } from '@/untils';
import { isUndef } from '@/untils/index';
export default {
  name: 'App',
  created() {
    document.title = !isUndef(getSession('showName'))
      ? getSession('showName')
      : '房屋征收信息公开系统';
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  text-decoration: none;
  color: #333333;
}
html,
body {
  height: 100%;
  width: 100%;
  background: url('./assets/img/u110.jpg') no-repeat center center;
  background-size: 100% 100%;
  background-position: center center;
  overflow: auto;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue